const UploadMedia = async (url, data) => {
  await fetch(url, {
    method: "PUT",
    headers: {
      // 'Content-type': 'image/*',
      // 'Content-Encoding': 'base64',
    },
    body: data,
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      console.log("Uplaod error: ", error);
    });

  return url;
};
export default UploadMedia;
